import script from "./devisModal.vue?vue&type=script&setup=true&lang=js"
export * from "./devisModal.vue?vue&type=script&setup=true&lang=js"

import "./devisModal.vue?vue&type=style&index=0&id=2bd15900&scoped=true&lang=scss"
import "./devisModal.vue?vue&type=style&index=1&id=2bd15900&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd15900"]])

export default __exports__